import * as addMinutes from "date-fns/addMinutes/index";

export class DateUtilities {
    public static UnixToDate(unix:number)
    {
        if(unix>0)
        {
            let date=new Date(unix*1000);
            date=new Date(date.setMinutes(date.getMinutes()+date.getTimezoneOffset()));
            return date;
        }else
            return null;
    }

    public static DateToUnix(date:Date)
    {
        return (date.getTime()/1000)+(date.getTimezoneOffset()*-1*60);
    }
}

